import {
    GET_DISCUSSIONS_REQUEST,
    GET_DISCUSSIONS_RESPONSE,
    GET_DISCUSSIONS_ERROR,
    CREATE_DISCUSSION_REQUEST,
    CREATE_DISCUSSION_RESPONSE,
    CREATE_DISCUSSION_ERROR,
    SET_IS_DISCUSSION_UPDATED,
    DISCUSSION_UPDATED,
    SET_DISCUSSION,
    GET_DISCUSSION_REQUEST,
    GET_DISCUSSION_RESPONSE,
    SET_NEW_DISCUSSION,
    CLOSE_DISCUSSION_REQUEST,
    CLOSE_DISCUSSION_RESPONSE,
    CLOSE_DISCUSSION_ERROR,
} from '../../actions/Discussions/discussions';
import { Action } from 'redux';
import { Discussions } from '../../models/Discussions/Discussion';
import { OrderedMap } from 'immutable';
import discussionStatuses from '../../lib/discussionStatuses';

export interface DiscussionsState {
    discussions: OrderedMap<number, Discussions>;
    loadingDiscussions: boolean;
    errorDiscussions: any;

    loadingCloseDiscussions: boolean;
    errorCloseDiscussions: any;
    loadingCreateDiscussions: boolean;
    errorCreateDiscussions: any;
    discussion: Discussions;
    loadingDiscussion: boolean;
    newDiscussion: Discussions;
    pageDiscussions: number;

    isActiveDiscussion: boolean;
    isUpdateDiscussion: boolean;
}

const initialState: DiscussionsState = {
    discussions: OrderedMap<number, Discussions>(),
    loadingDiscussions: false,
    errorDiscussions: null,

    loadingCloseDiscussions: false,
    errorCloseDiscussions: null,
    loadingCreateDiscussions: false,
    errorCreateDiscussions: null,
    discussion: {} as Discussions,
    loadingDiscussion: false,
    newDiscussion: {} as Discussions,
    pageDiscussions: 1,

    isActiveDiscussion: false,
    isUpdateDiscussion: false,
};

export function discussionsState(state: DiscussionsState = initialState, action: Action) {
    switch (action.type) {
        case GET_DISCUSSIONS_REQUEST: {
            return {
                ...state,
                discussions: initialState.discussions,
                loadingDiscussions: true,
                errorDiscussions: initialState.errorDiscussions,
            };
        }
        case GET_DISCUSSIONS_RESPONSE: {
            const result: Discussions[] = (action as any).response.result;
            const discussions = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.discussions);
            const pageDiscussions = (action as any).response.pagination.next_page;
            let isActiveDiscussion = false;
            discussions.map(discussion => (discussion!.status_id !== discussionStatuses.close.id && discussion!.status_id !== discussionStatuses.completed.id) ? isActiveDiscussion = true : {});
            return {
                ...state,
                loadingDiscussions: false,
                discussions,
                pageDiscussions,
                isActiveDiscussion
            };
        }
        case GET_DISCUSSIONS_ERROR: {
            const errorDiscussions = (action as any).error;
            return {
                ...state,
                loadingDiscussions: false,
                errorDiscussions,
            };
        }
        case CREATE_DISCUSSION_REQUEST: {
            return {
                ...state,
                newDiscussion: initialState.newDiscussion,
                loadingCreateDiscussions: true,
                errorCreateDiscussions: initialState.errorCreateDiscussions,
            };
        }
        case CREATE_DISCUSSION_RESPONSE: {
            const newDiscussion: Discussions = (action as any).response.result;
            const discussions = state.discussions.set(newDiscussion.id, newDiscussion);
            return {
                ...state,
                discussions,
                newDiscussion,
                loadingCreateDiscussions: false,
            };
        }
        case CREATE_DISCUSSION_ERROR: {
            const errorCreateDiscussions = (action as any).error;
            return {
                ...state,
                loadingCreateDiscussions: false,
                errorCreateDiscussions,
            };
        }
        case CLOSE_DISCUSSION_REQUEST: {
            return {
                ...state,
                loadingCloseDiscussions: true,
                errorCloseDiscussions: initialState.errorCloseDiscussions,
            };
        }
        case CLOSE_DISCUSSION_RESPONSE: {
            const newDiscussion: Discussions = (action as any).response.result;
            const discussions = state.discussions.set(newDiscussion.id, newDiscussion);
            return {
                ...state,
                discussions,
                loadingCloseDiscussions: false,
            };
        }
        case CLOSE_DISCUSSION_ERROR: {
            const errorCloseDiscussions = (action as any).error;
            return {
                ...state,
                loadingCloseDiscussions: false,
                errorCloseDiscussions,
            };
        }
        case SET_DISCUSSION: {
            const discussion = (action as any).discussion;
            return {
                ...state,
                discussion,
            };
        }
        case DISCUSSION_UPDATED: {
            return {
                ...state,
                isUpdateDiscussion: true
            };
        }
        case SET_IS_DISCUSSION_UPDATED: {
            return {
                ...state,
                isUpdateDiscussion: (action as any).value
            };
        }
        case GET_DISCUSSION_REQUEST: {
            return {
                ...state,
                loadingDiscussion: true
            };
        }
        case GET_DISCUSSION_RESPONSE: {
            return {
                ...state,
                discussion: (action as any).response.result,
                loadingDiscussion: false
            };
        }
        case SET_NEW_DISCUSSION: {
            return {
                ...state,
                discussion: state.newDiscussion,
                newDiscussion: initialState.newDiscussion
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Discussions/discussions.ts